import styles from './menu.module.scss';
import MaterialMenu from '@mui/material/Menu';
import MaterialMenuList from '@mui/material/MenuList';
import MaterialMenuItem from '@mui/material/MenuItem';

/* eslint-disable-next-line */
export interface MenuProps {
  open: boolean,
  anchorEl?: any,
  // autoFocus?: boolean,
  children: any,
  // classes?: object,
  // disableAutoFocusItem?: boolean,
  // MenuListProps?: object,
  onClose?: (event: object, reason: string) => void,
  // PopoverClasses?: object,
  // sx?: any,
  // transitionDuration?: 'auto' | number | { appear?: number, enter?: number, exit?: number },
  // TransitionProps?: object,
  // variant?:
  // 'menu'
  // | 'selectedMenu'
  onClick?: (...args: any[]) => void,
  anchorOrigin?: {
    horizontal: 'center' | 'left' | 'right' | number,
    vertical: 'bottom' | 'center' | 'top' | number
  }
  transformOrigin?: {
    horizontal: 'center' | 'left' | 'right' | number,
    vertical: 'bottom' | 'center' | 'top' | number
  },
  sx?: any
}

export interface MenuListProps {
  // autoFocus?: boolean,
  // autoFocusItem?: boolean,
  children: any,
  // disabledItemsFocusable?: boolean,
  disableListWrap?: boolean,
  // variant?:
  // 'menu'
  // | 'selectedMenu'
}

export interface MenuItemProps {
  // autoFocus?: boolean,
  children: any,
  // classes?: object,
  // component?: any,
  dense?: boolean,
  disableGutters?: boolean,
  divider?: boolean,
  style?: any,
  // focusVisibleClassName?: string,
  // sx?: any,
  onClick?: (...args: any[]) => void,
  value?: any,
  disabled?: boolean,
  hidden?: boolean,
  selected?: boolean
}

export function Menu(props: MenuProps) {
  return (
    <MaterialMenu
      open={props.open}
      onClose={props.onClose}
      anchorEl={props.anchorEl}
      anchorOrigin={props.anchorOrigin}
      transformOrigin={props.transformOrigin}
      sx={props.sx}>
      {props.children}
    </MaterialMenu>
  );
}

export function MenuList(props: MenuListProps) {
  return (
    <MaterialMenuList
      disableListWrap={props.disableListWrap}>
      {props.children}
    </MaterialMenuList>
  );
}

export function MenuItem(props: MenuItemProps) {
  return (
    <MaterialMenuItem
      onClick={props.onClick}
      value={props.value}
      style={props.style}
      disabled={props.disabled}
      hidden={props.hidden}
      dense={props.dense}
      disableGutters={props.disableGutters}
      divider={props.divider}
      selected={props.selected}>
      {props.children}
    </MaterialMenuItem>
  );
}

export default Menu;